<template>
  <div class="animated fadeIn">
    <template v-if="filtered_samples.length">
      <b-table
        :items="filtered_samples"
        :fields="table.fields"
        v-sortable="table.sorts"
        id="schedule-sample-table"
        :per-page="table.per_page"
        :current-page="table.current_page"
        responsive
      >
        <template #cell(position)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(select)="data">
          <schedule-sample-checkbox
            :sample="data.item"
            :schedule_id="schedule_id"
            placement="cohort_table"
            @updateCohortSampleList="updateCohortSampleList"
          />
        </template>
        <template #cell(customer)="data">
          {{ getProjectData(data.item, "customerName") }}
        </template>
        <template #cell(project)="data">
          {{ getProjectData(data.item, "pid") }}
        </template>
        <template #cell(sample)="data">
          {{
            data.item
              ? `${data.item.publicNumber()}(${data.item.receiving_id})`
              : null
          }}
        </template>
        <template #cell(days_til_due)="data">
          {{ data.item ? getDaysTilDue(data.item) : null }}
        </template>
        <template #cell(days_since_sent)="data">
          {{ data.item ? getDaysSinceSent(data.item) : null }}
        </template>
        <template #cell(days_since_received)="data">
          {{ data.item ? getDaysSinceReceived(data.item) : null }}
        </template>
        <template #cell(turnaround)="data">
          {{
            data.item && data.item.submission && data.item.submission.turnaround
              ? data.item.getSubmission().turnaround.name
              : null
          }}
        </template>
      </b-table>
      <custom-table-pagination
        :options="table.per_page_options"
        :current_page="table.current_page"
        :per_page="table.per_page"
        :total_rows="filtered_samples.length"
        @update="updatePaginationData"
        table_id="schedule-sample-table"
        selector_prefix="Samples per page"
      />
    </template>
    <div v-else>
      <b-alert show class="mb-4">No samples were found.</b-alert>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CustomTablePagination from "@/components/shared/CustomTablePagination";
import ScheduleSampleCheckbox from "./ScheduleSampleCheckbox";
import sortable from "@/components/shared/directives/Sortable";
import { mapGetters } from "vuex";

export default {
  name: "SampleCohortSelector",
  components: { ScheduleSampleCheckbox, CustomTablePagination },
  directives: { sortable },
  props: {
    filtered_samples: {
      type: Array,
      default: () => null,
    },
    schedule_id: {
      type: String,
      defualt: "",
    },
  },
  computed: {
    ...mapGetters({
      schedule_form: "scheduleForm",
    }),
    selected_samples() {
      return this.schedule_form.samples;
    },
  },
  data() {
    return {
      table: {
        fields: [
          { key: "position", label: "Pos." },
          { key: "select", label: "Sel." },
          { key: "customer", label: "Customer" },
          { key: "project", label: "Project" },
          { key: "sample", label: "Sample" },
          { key: "days_til_due", label: "Due" },
          { key: "days_since_sent", label: "Sent" },
          { key: "days_since_received", label: "Rec." },
          { key: "turnaround", label: "TO." },
        ],
        per_page: 500,
        current_page: 1,
        per_page_options: [500, 750, 1000, 1250],
      },
    };
  },
  methods: {
    getProjectData(sample, field) {
      if (!sample.submission) {
        return null;
      }

      const project = sample.getSubmission().getProject();
      switch (field) {
        case "pid":
          return project.publicNumber();
        case "customerName":
          return project.getCustomer() ? project.getCustomer().short_name : null;
        default:
          return null;
      }
    },
    updateCohortSampleList(update) {
      this.$emit("updateSchedule", update);
    },
    updatePaginationData({ field, value }) {
      this.table[field] = value;
    },
    getStatusLogByName(sample, name) {
      const logs = sample.getSampleStatusLogs();
      let selected_log = null;

      logs.each((log) => {
        const status = log.getSampleStatus();

        if (status && status.status === name) {
          selected_log = log;
        }
      });
      return selected_log;
    },
    getDaysTilDue(sample) {
      return 100 - this.getDaysSinceSent(sample);
    },
    getDaysSinceSent(sample) {
      const log = this.getStatusLogByName(sample, "Sent");

      if (log) {
        const date1 = moment(log.created_at);
        const date2 = moment();

        return date2.diff(date1, "days");
      }
      return null;
    },
    getDaysSinceReceived(sample) {
      let log = this.getStatusLogByName(sample, "Received");

      if (log) {
        let date1 = moment(log.created_at);
        let date2 = moment();
        return date2.diff(date1, "days");
      }
      return null;
    },
  },
  watch: {
    "table.per_page": {
      handler(value) {
        this.$emit("updatePerPage", value);
      },
    },
    "table.current_page": {
      handler(value) {
        this.$emit("updateCurrentPage", value);
      },
    },
  },
};
</script>
